import React, { useEffect, useRef, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  useMapEvent,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { FiMaximize, FiMinimize } from "react-icons/fi";
import marker from "../../Images/pin.png";
// 📍 Custom marker icon
const bouncingDropIcon = new L.Icon({
  iconUrl: marker,
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [35, 35],
  iconAnchor: [12, 41],
  shadowSize: [41, 41],
  className: "drop-bounce-marker",
});
const MapClickHandler = ({ setMarkerPosition }) => {
  useMapEvent("click", (e) => {
    const lat = parseFloat(e.latlng.lat.toFixed(7));
    const lng = parseFloat(e.latlng.lng.toFixed(7));
    setMarkerPosition({ lat, lng });
  });
  return null;
};
// 📍 Locate Me Button
const LocateControl = ({ setMarkerPosition }) => {
  const map = useMap();
  useEffect(() => {
    const locateButton = L.control({ position: "topright" });
    locateButton.onAdd = function () {
      const div = L.DomUtil.create(
        "div",
        "leaflet-bar leaflet-control leaflet-control-custom"
      );
      div.innerHTML = "📍";
      div.title = "Locate Me";
      Object.assign(div.style, {
        backgroundColor: "white",
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
        cursor: "pointer",
        fontSize: "20px",
        marginTop: "65px",
        marginRight: "15px",
      });
      L.DomEvent.disableClickPropagation(div);
      L.DomEvent.disableScrollPropagation(div);
      L.DomEvent.on(div, "click", (e) => {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);

        map.locate({
          watch: false,
          enableHighAccuracy: true,
        });
      });
      // div.onclick = () => {
      //   map.locate({
      //     watch: false,
      //     enableHighAccuracy: true,
      //   });
      // };
      return div;
    };

    locateButton.addTo(map);

    const onLocationFound = (e) => {
      const { lat, lng } = e.latlng;
      setMarkerPosition({ lat, lng });

      map.flyTo([lat, lng], 16, {
        animate: true,
        duration: 1.0,
        easeLinearity: 0.25,
      });
    };

    // const onLocationFound = (e) => {
    //   const { lat, lng } = e.latlng;
    //   setMarkerPosition({ lat, lng });
    //   setTimeout(() => {
    //     map.invalidateSize();
    //     map.flyTo([lat, lng], 16, {
    //       animate: true,
    //       duration: 1.5,
    //     });
    //   }, 100);
    // };

    const onLocationError = (e) => {
      alert("Could not determine your location: " + e.message);
    };

    map.on("locationfound", onLocationFound);
    map.on("locationerror", onLocationError);

    return () => {
      map.off("locationfound", onLocationFound);
      map.off("locationerror", onLocationError);
      map.removeControl(locateButton);
    };
  }, [map, setMarkerPosition]);

  return null;
};
const MapInitializer = ({ onMapReady, markerPosition }) => {
  const map = useMap();

  useEffect(() => {
    if (map) {
      onMapReady(map);
      if (markerPosition?.lat && markerPosition?.lng) {
        map.setView([markerPosition.lat, markerPosition.lng], 16, {
          animate: true,
        });
      }
    }
  }, [map, markerPosition, onMapReady]);

  return null;
};
const Stopaddmap = ({ markerPosition, setMarkerPosition }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const mapRef = useRef();
  const containerRef = useRef(null);

  const toggleFullscreen = () => {
    const element = containerRef.current;
    const animateZoomToMarker = () => {
      mapRef.current?.invalidateSize();
      if (markerPosition && mapRef.current) {
        mapRef.current.flyTo([markerPosition.lat, markerPosition.lng], 16, {
          animate: true,
          duration: 1.5,
        });
      }
    };

    if (!document.fullscreenElement) {
      element.requestFullscreen().then(() => {
        setIsFullscreen(true);
        setTimeout(animateZoomToMarker, 300);
      });
    } else {
      document.exitFullscreen().then(() => {
        setIsFullscreen(false);
        setTimeout(animateZoomToMarker, 300);
      });
    }
  };

  const updateLatLng = (type, value) => {
    if (!markerPosition) return;
    const num = parseFloat(value);
    if (isNaN(num)) return;
    const updated = {
      ...markerPosition,
      [type]: num,
    };
    setMarkerPosition(updated);
    if (mapRef.current) {
      mapRef.current.flyTo([updated.lat, updated.lng], 16, {
        animate: true,
        duration: 1.2,
      });
    }
  };

  return (
    <div
      ref={containerRef}
      style={{
        height: isFullscreen ? "100vh" : "40vh",
        width: "100%",
        position: "relative",
      }}
    >
      <MapContainer
        center={[20.2961, 85.8245]}
        zoom={13}
        style={{ height: "100%", width: "100%" }}
        attributionControl={false}
        zoomControl={false}
      >
        <MapInitializer
          onMapReady={(map) => (mapRef.current = map)}
          markerPosition={markerPosition}
        />
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <MapClickHandler setMarkerPosition={setMarkerPosition} />
        <LocateControl setMarkerPosition={setMarkerPosition} />

        {markerPosition && (
          <Marker
            position={[markerPosition.lat, markerPosition.lng]}
            icon={bouncingDropIcon}
            eventHandlers={{ click: () => setMarkerPosition(null) }}
          />
        )}
      </MapContainer>

      {/* Fullscreen Button */}
      <button
        onClick={toggleFullscreen}
        title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
        style={{
          position: "absolute",
          top: 15,
          right: 15,
          zIndex: 1000,
          width: "40px",
          height: "40px",
          border: "none",
          borderRadius: "50%",
          backgroundColor: "white",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        {isFullscreen ? <FiMinimize size={20} /> : <FiMaximize size={20} />}
      </button>

      {/* Latitude & Longitude Input */}
      {markerPosition && (
        <div
          style={{
            position: "absolute",
            top: 15,
            left: 15,
            zIndex: 1000,
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            backgroundColor: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          <label style={{ fontSize: "12px", fontWeight: "bold" }}>
            {/* Lat: */}
            <input
              type="number"
              value={markerPosition.lat}
              step="0.000001"
              onChange={(e) => updateLatLng("lat", e.target.value)}
              style={{
                padding: "5px 8px",
                fontSize: "14px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                width: "150px",
                marginTop: "2px",
                textAlign: "left", // 👈 Add this
              }}
            />
          </label>
          <label style={{ fontSize: "12px", fontWeight: "bold" }}>
            {/* Lng: */}
            <input
              type="number"
              value={markerPosition.lng}
              step="0.000001"
              onChange={(e) => updateLatLng("lng", e.target.value)}
              style={{
                padding: "5px 8px",
                fontSize: "14px",
                borderRadius: "5px",
                border: "1px solid #ccc",
                width: "150px",
                marginTop: "2px",
                textAlign: "left", // 👈 Add this
              }}
            />
          </label>
        </div>
      )}
    </div>
  );
};

export default Stopaddmap;
